<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col cols="12" md="7" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <b-button variant="outline-primary" class="btn-icon" @click="$router.go(-1)">
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">{{ recordId ? 'Risk Category Edit' : 'Risk Category Add' }}</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="formRules">
        <b-form>
          <b-row>
            <b-col cols="2">
              <b-form-group label="Order Number" label-for="order">
                <validation-provider name="order" #default="{ errors }">
                  <b-form-input id="order" type="number" v-model.number="formData.order" @change="checkOrder" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group label="Title" label-for="title">
                <validation-provider name="title" #default="{ errors }" rules="required">
                  <b-form-input id="title" type="text" v-model="formData.title" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" class="mt-1">
              <b-form-group label="Category Colour" label-for="color">
                <app-color-palette-vue
                  v-if="!formShow"
                  @update:selected-color="colorSelectedHandler"
                  :row-number="16"
                  :selected-color-data="formData.colorObj && formData.colorObj.textColor"
                  :selected-bg-color-data="formData.colorObj && formData.colorObj.bgColor"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button type="submit" @click.prevent="formSubmitted" variant="primary" class="float-right">
                {{ recordId ? 'Save Changes' : 'Save' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { onUnmounted } from '@vue/composition-api';
import settingsStoreModule from '../settingsStoreModule';
import vSelect from 'vue-select';
import router from '@/router';
import AppColorPaletteVue from '@/@core/layouts/components/AppColorPalette.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';

export default {
  components: { vSelect, ToastificationContent, AppColorPaletteVue, ValidationProvider, ValidationObserver },
  setup() {
    if (!store.hasModule('settings')) store.registerModule('settings', settingsStoreModule);
    onUnmounted(() => { if (store.hasModule('settings')) store.unregisterModule('settings'); });
  },
  data() {
    return {
      formData: { title: '', order: null, colorObj: { textColor: '#000', bgColor: '#333366' } },
      formShow: false,
      recordId: null,
      required,
    };
  },
  mounted() {
    if (router.currentRoute.params.id) {
      this.recordId = parseInt(router.currentRoute.params.id);
      this.formShow = true;
      store.dispatch('settings/getRiskCategoryById', { id: this.recordId }).then((res) => {
        this.formData = { ...res.data, colorObj: { textColor: '#000', bgColor: res.data.color || '#333366' } };
        this.formShow = false;
      }).catch(() => { this.formShow = false; });
    }
  },
  methods: {
    checkOrder() {
      store.dispatch('settings/checkRiskCategoryOrderNumber', this.formData.order).then((res) => {
        if (res.data.existing && !this.recordId) {
          const orders = res.data.existingOrders;
          let n = 1;
          while (orders.includes(n)) n++;
          this.formData.order = n;
        }
      });
    },
    colorSelectedHandler(textColor, bgColor) {
      this.formData.colorObj = { textColor, bgColor };
    },
    formSubmitted() {
      this.$refs.formRules.validate().then((success) => {
        if (!success) return;
        if (!this.formData.colorObj?.bgColor) {
          this.$toast({ component: ToastificationContent, props: { title: 'Error', text: 'Please select a colour.', icon: 'AlertTriangleIcon', variant: 'warning' } });
          return;
        }
        this.formShow = true;
        const payload = { ...this.formData, color: this.formData.colorObj.bgColor };
        const action = this.recordId ? 'settings/updateRiskCategory' : 'settings/saveRiskCategory';
        store.dispatch(action, payload).then(() => {
          this.$toast({ component: ToastificationContent, props: { title: 'Successful', text: `✔️ Risk Category ${this.recordId ? 'updated' : 'added'} successfully`, icon: 'ThumbsUpIcon', variant: 'success' } });
          router.push({ name: 'settings-risk-categories' });
        }).catch((err) => {
          this.formShow = false;
          const msg = err.response?.data?.errors?.title?.[0] || 'An error occurred.';
          this.$toast({ component: ToastificationContent, props: { title: 'Error', text: msg, icon: 'AlertCircleIcon', variant: 'danger' } });
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
